import { Hash } from "viem";
import Decimal from "decimal.js";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { useTokenListByChain } from "../../../hooks/useTokenListByChain";
import { useTokenlistMetadataByChain } from "../../../hooks/queries/tokens-queries";
import { Text } from "../../general/Text";
import { css, SerializedStyles, Theme } from "@emotion/react";
import { SkeletonBlock } from "../../general/Skeleton";
import React from "react";

export const TokenRowStats = ({
  tokenAddress,
  isLoading,
  balanceUsd,
}: {
  tokenAddress: Hash;
  isLoading: boolean;
  balanceUsd: Decimal;
}) => {
  const { theme, chain } = GlobalStore.useState(s => {
    return {
      theme: s.theme,
      chain: s.network,
    };
  });
  const tokenList = useTokenListByChain();
  const { data: tokenlistMetadata, isError } = useTokenlistMetadataByChain({ chainId: chain.id });

  if (tokenList == null || tokenlistMetadata == null || isError) return null;

  const tokenMetadata = tokenlistMetadata[tokenAddress];
  if (tokenMetadata == null) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "right",
        alignItems: "end",
      }}
    >
      {tokenMetadata.p && (
        <Text
          textStyle="Title"
          size="Small"
          shouldScale={true}
          textCss={css`
            visibility: ${balanceUsd.isZero() ? "hidden" : "none"};
          `}
        >
          ${balanceUsd.toFixed(2)}
        </Text>
      )}
      {tokenMetadata.c != null && (
        <PercentageChange isLoading={isLoading} pctChange={tokenMetadata.c} theme={theme} />
      )}
    </div>
  );
};

export const PercentageChange = ({
  isLoading,
  pctChange,
  styles,
  theme,
}: {
  isLoading: boolean;
  pctChange: number;
  styles?: SerializedStyles;
  theme: Theme;
}) => {
  if (isLoading) {
    return (
      <div style={{ marginBottom: 3 }}>
        <SkeletonBlock width={49} height={14} style={{ maxWidth: 49, maxHeight: 14 }} />
      </div>
    );
  }

  const isPositive = pctChange >= 0;
  return (
    <Text
      textStyle={"Title"}
      size={"XS"}
      color={isPositive ? theme["Colour ramps"].Green[600] : theme["Colour ramps"].Coral[500]}
      textCss={styles}
    >
      {isPositive ? "+" : "-"}
      {Math.abs(pctChange).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
      %
    </Text>
  );
};
